import { Pipe, PipeTransform } from "@angular/core";
import { UtilEnumHelper } from "@rr/shared-util";

@Pipe({
  name: "rrUiCoreValueAsEnumKey",
})
export class UiCoreValueAsEnumKeyPipe implements PipeTransform {
  transform(value: unknown, enumType: object, emptyPlaceholder = "-") {
    return UtilEnumHelper.valueAsEnumKey(value, enumType, emptyPlaceholder);
  }
}
